import React, { Component } from 'react';
import Projects from 'components/Projects/Projects';

export default class ProjectsView extends Component {
    render() {
        return (
            <div className="fade-show">
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="header">Proyectos</h1>
                    </div>
                </div>

                <Projects />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/ProjectsView/ProjectsView.jsx